import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export const useNotificationData = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
) => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<string[][]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !username) return;

    const load = async () => {
      try {
        setLoading(true);

        const ntName = "positive\\"+username;
        const res = await client.get(
          "/EmployeeInformation/KPI",
          { params: { username: ntName, year, quarter } }
        );

        const kpis = res.data;

        if (!Array.isArray(kpis) || kpis.length === 0) {
          setData(undefined);
          return;
        }

        const formatted = kpis.map((row: any) => [
          row.area,
          String(row.opened),
          String(row.closed),
          String(row.latency),
        ]);

        setData(formatted);
      } catch (err) {
        console.error(err);
        setData(undefined);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { data, loading };
};